module.exports = __webpack_public_path__ + "static/img/bg_benefit_four_ok.9182936.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_benefit_four_ok.png
// module id = aBgB
// module chunks = 0